import { render, staticRenderFns } from "./ListStudents.vue?vue&type=template&id=9798fd44&scoped=true"
import script from "./ListStudents.vue?vue&type=script&lang=js"
export * from "./ListStudents.vue?vue&type=script&lang=js"
import style0 from "./ListStudents.vue?vue&type=style&index=0&id=9798fd44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9798fd44",
  null
  
)

export default component.exports